package br.com.texeratx.boardgametimeapp.core.spotify

import br.com.texeratx.boardgametimeapp.core.utils.getPlatform

fun isSpotifySupportedOnCurrentPlatform(): Boolean = getPlatform().name != "Web"
